window.addEventListener("load", function () {
  // NO SCROLL BODY WHEN CART IS OPEN
  // Select the target element
  const targetElement = document.querySelector("cart-drawer.drawer");

  if(targetElement){
    // Create a callback function to execute when mutations are observed
    const callback = function (mutationsList) {
      // console.warn("mutationList", mutationsList)
      for (let mutation of mutationsList) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        const targetClassList = mutation.target.classList;
        if (targetClassList.contains("active")) {
        // Do something when the class 'active' is added
        $("html, body").css("overflow-y", "hidden");
        } else {
        // Do something else when the class 'active' is removed
        $("html, body").css("overflow-y", "auto");
        }
      }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target element for configured mutations
    observer.observe(targetElement, { attributes: true });
  }

  // UPDATE CART QUANTITY ON BUBBLE
  // Select the element to observe
  const cartCountObservedElement = document.querySelector('.wbhcart');

  const cartCountCallback = function (mutationsList) {
    const cartCountTarget = document.querySelector('.gth-cart-button-float span.wbhcartitem');

    if (cartCountTarget) {
      const observedCount = cartCountObservedElement.querySelector('span.wbhcartitem').textContent;
      cartCountTarget.textContent = observedCount;
    }
  };

  // Create an observer instance linked to the callback function
  const cartCountObserver = new MutationObserver(cartCountCallback);

  // Start observing the target element for configured mutations
  cartCountObserver.observe(cartCountObservedElement, { childList: true, characterData: true, subtree: true });

  // Observer configuration
  const cartDrawerFooterConfig = { childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  const pickeasyPickerCallback = (mutationList, observer) => {
    // console.warn('mutationList', mutationList);
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach((addedNode) => {
          // Ensure addedNode is an element node before accessing querySelector
          if (addedNode.nodeType === Node.ELEMENT_NODE) {
            const slotsTable = addedNode.querySelector('.neo-scroll .neo-table.neo-grid.neo-time-grid');
            if (slotsTable) {
              // Process table slots when the table is added
              processTableSlots(slotsTable);
            }

          }
        });
      }
    }
  };

  // Function to process the time slots, add classes based on duration, and organize columns
  const processTableSlots = (table) => {
    const rows = table.querySelectorAll('.neo-tr');
    let twoHourSlots = [];
    let fourHourSlots = [];
    let sevenHourSlots = [];

    rows.forEach(row => {

    // console.log(row)

      const cells = row.querySelectorAll('.neo-cell');
      cells.forEach(cell => {
        const timeSpan = cell.querySelector('.neo-time');
        if (timeSpan) {
          const timeText = timeSpan.textContent;
          if (timeText.includes(' - ')) {
            const [start, end] = timeText.split(' - ');
            const duration = calculateDuration(start, end);

            // Assign class based on duration
            if (duration === 2) {
              cell.classList.add('pickeasy-two-hour');
              twoHourSlots.push(cell);
            } else if (duration === 4) {
              cell.classList.add('pickeasy-four-hour');
              fourHourSlots.push(cell);
            } else if (duration === 7) {
              cell.classList.add('pickeasy-seven-hour');
              sevenHourSlots.push(cell);
            }
          }
        }
      });
    });

    // Ensure slots are organized by duration in columns
    rows.forEach((row, index) => {

      // Clear cells only if it's required to rearrange based on duration
      row.innerHTML = ''; // Reset the row

      // Append cells for 2-hour or 4-hour slots depending on row index
      if (index < twoHourSlots.length) {
        row.appendChild(twoHourSlots[index]);
      }
      if (index < fourHourSlots.length) {
        row.appendChild(fourHourSlots[index]);
      }
      if (index < sevenHourSlots.length) {
        row.appendChild(sevenHourSlots[index]);
      }
    });
  };

  // Helper function to calculate duration in hours
  const calculateDuration = (start, end) => {
    const startDate = new Date(`1970-01-01T${convertTo24Hour(start)}:00`);
    const endDate = new Date(`1970-01-01T${convertTo24Hour(end)}:00`);
    const duration = (endDate - startDate) / (1000 * 60 * 60);  // Convert ms to hours
    return duration;
  };

  // Convert 12-hour time format to 24-hour format
  const convertTo24Hour = (time) => {
    const [timePart, modifier] = time.split(' ');
    let [hours, minutes] = timePart.split(':').map(Number);

    // Handle AM/PM conversion
    if (modifier === 'PM' && hours !== 12) {
      hours += 12;
    }
    if (modifier === 'AM' && hours === 12) {
      hours = 0;
    }

    // Ensure minutes is defined if not provided in the input
    minutes = minutes || 0;

    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  };

  // Function to initialize the observer once cartDrawerFooter is available
  const initObserver = () => {
    const cartDrawerFooter = document.querySelector(".cart__footer");
    if (cartDrawerFooter) { // Check if cartDrawerFooter exists
      const cartDrawerFooterObserver = new MutationObserver(pickeasyPickerCallback);
      cartDrawerFooterObserver.observe(cartDrawerFooter, cartDrawerFooterConfig);
      clearInterval(observerInterval); // Stop checking once initialized
      // console.log("Observer initialized on cartDrawerFooter.");
    } else {
      // console.warn("Waiting for cartDrawerFooter element to be available...");
    }
  };

  // Check every 100ms until the element is available
  const observerInterval = setInterval(initObserver, 100);
});

const orderSlotsTargetNode = document.body; // You could narrow this down if you know where it will be added.
const orderSlotsObserverOptions = {
  childList: true,
  subtree: true
};

const orderSlotsObserverCallback = (orderSlotsMutationsList, orderSlotsObserver) => {
  for (const orderSlotsMutation of orderSlotsMutationsList) {
    if (orderSlotsMutation.type === 'childList') {
      const orderSlotsAttr = document.querySelector('#order-slots-cart-attributes');
      if (orderSlotsAttr) {
        // Extract data from the orderSlotsAttr and set it to the respective inputs

        document.querySelector("input[data-id-name='#order-fulfillment-type']").value = orderSlotsAttr.querySelector("#order-fulfillment-type").value
        document.querySelector("input[data-id-name='#order-fulfilment-date']").value = orderSlotsAttr.querySelector("#order-fulfilment-date").value,
        document.querySelector("input[data-id-name='#order-fulfilment-time']").value = orderSlotsAttr.querySelector("#order-fulfilment-time").value,
        document.querySelector("input[data-id-name='#translated-order-fulfilment-date']").value = orderSlotsAttr.querySelector("#translated-order-fulfilment-date").value,
        document.querySelector("input[data-id-name='#translated-order-fulfilment-time']").value = orderSlotsAttr.querySelector("#translated-order-fulfilment-time").value,
        document.querySelector("input[data-id-name='#order-location']").value = orderSlotsAttr.querySelector("#order-location").value,
        document.querySelector("input[data-id-name='#order-location-zip']").value = orderSlotsAttr.querySelector("#order-location-zip").value,
        document.querySelector("input[data-id-name='#checkoutNotes']").value = orderSlotsAttr.querySelector("#order-fulfilment-date").value + " - " + orderSlotsAttr.querySelector("#order-fulfilment-time").value


        // orderSlotsObserver.disconnect(); // Stop observing once found and processed
        return;
      }
    }
  }
};

const orderSlotsObserver = new MutationObserver(orderSlotsObserverCallback);
orderSlotsObserver.observe(orderSlotsTargetNode, orderSlotsObserverOptions);
